import { __assign, __awaiter, __generator } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { useMemo, useState, useEffect } from "react";
import pickBy from "lodash/pickBy";
import FolderIcon from "@mui/icons-material/Folder";
import { FieldsForm, PangeaModal } from "@pangeacyber/react-mui-shared";
import { getCreateFolderFields } from "./fields";
import { useStoreFileViewerContext } from "../../hooks/context";
import { alertOnError } from "../AlertSnackbar/hooks";
var CreateNewFolderButton = function (_a) {
    var _b;
    var ButtonProps = _a.ButtonProps, onClose = _a.onClose, _c = _a.hideFolderOptions, hideFolderOptions = _c === void 0 ? false : _c;
    var _d = useStoreFileViewerContext(), apiRef = _d.apiRef, reload = _d.reload, parent = _d.parent;
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    var _f = useState(false), loading = _f[0], setLoading = _f[1];
    var _g = useState({
        name: "",
        parent_id: (_b = parent === null || parent === void 0 ? void 0 : parent.id) !== null && _b !== void 0 ? _b : "/",
    }), obj = _g[0], setObj = _g[1];
    useEffect(function () {
        var _a;
        setObj({
            name: "",
            parent_id: (_a = parent === null || parent === void 0 ? void 0 : parent.id) !== null && _a !== void 0 ? _a : "/",
        });
    }, [open]);
    var fields = useMemo(function () {
        return getCreateFolderFields({ apiRef: apiRef, hideFolderOptions: hideFolderOptions });
    }, []);
    var handleClose = function () {
        setOpen(false);
        onClose();
    };
    var handleCreateFolder = function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!apiRef.folderCreate)
                return [2 /*return*/];
            setLoading(true);
            return [2 /*return*/, (apiRef
                    // @ts-ignore
                    .folderCreate(pickBy(body, function (v, k) { return k !== "path"; }))
                    .then(function () {
                    setLoading(false);
                    reload();
                })
                    .catch(function (error) {
                    reload();
                    alertOnError(error);
                    setLoading(false);
                }))];
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ variant: "text" }, ButtonProps, { startIcon: _jsx(FolderIcon, { fontSize: "small" }), onClick: function () { return setOpen(true); }, children: "Folder" })), _jsx(PangeaModal, { open: open, onClose: handleClose, title: "Create Folder", size: "small", children: _jsx(FieldsForm, { object: obj, fields: fields, onSubmit: function (values) {
                        if (values.parent_id === "/") {
                            values.parent_id = "";
                        }
                        // @ts-ignore
                        return handleCreateFolder(pickBy(values, function (v) { return !!v; })).finally(handleClose);
                    }, clearable: true, onCancel: handleClose, disabled: loading }) })] }));
};
export default CreateNewFolderButton;
